import Modal from "react-modal";

export default function ModalDetails({showModals, details}){
    return (
        <Modal
            isOpen={showModals?.state?.details}
            onRequestClose={() => showModals?.setState((prevState) => ({...prevState, details: false}))}
            className="modal-content"
            contentLabel="Características"
            ariaHideApp={false}
            keepMounted
        >
            <div className="formDiv">
                <table>
                    <thead>
                    <tr>
                        {details?.labels?.map((detailLabel, index) => {
                        return (
                            <th key={index}>{detailLabel}</th>
                        )
                        })}
                    </tr>
                    </thead>
                    <tbody>
                    {details?.data?.map((detailData, index)=> {
                        return(
                            <tr key={index}>
                            {details?.indexes?.map((label, i)=>{
                                return(
                                <td scope="col">{detailData[label]}</td>
                                )
                            })}
                            </tr>
                        )
                    })}
                    {details?.data?.length === 0 &&
                        <tr>
                            <td colSpan={3}><label className='required'>Nenhum registro encontrado!</label></td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>
            <div className="formDiv">
                <button type="button" className="buttonCancel" onClick={() => showModals?.setState((prevState) => ({...prevState, details: false}))}>Fechar</button>
            </div>
        </Modal>
    )
}